<div class="pb-8">
  <h3 class="pt-12">{{ 'audit' | customerTerm }} Information</h3>
  @if (audit!=undefined) {
    <div class="">
      <div class="pt-8">
        <label>
          <span class="text-sm">Name*</span>
          <input [(ngModel)]="audit.AuditName" (ngModelChange)="auditChanged()" type="text" class="text-box" />
        </label>
      </div>
      <div class="pt-8">
        <label>
          <span class="text-sm">Type*</span>
          <select [(ngModel)]="audit.AuditInfo.AuditType" (ngModelChange)="auditChanged()"
            [compareWith]="auditTypeComparison" class="text-box">
            @for (t of _auditTypes; track t) {
              <option [disabled]="!t.Active" [ngValue]="t">{{t.Description}}
              </option>
            }
          </select>
        </label>
      </div>
      <div class="pt-8">
        <label>
          <span class="text-sm">Code</span>
          <input [(ngModel)]="audit.AuditInfo.Code" (ngModelChange)="auditChanged()" type="text"
            class="text-box" />
          </label>
        </div>
        <div class="pt-8">
          <label>
            <span class="text-sm">Description</span>
            <textarea [(ngModel)]="audit.AuditInfo.ReportDescription" (ngModelChange)="auditChanged()" type="text"
            class="text-box" rows="3"></textarea>
          </label>
        </div>
        <div class="pt-8">
          <label>
            <span class="text-sm">Revision Date</span>
            <input [(ngModel)]="audit.AuditInfo.RevisionDate" (ngModelChange)="auditChanged()" type="text"
              class="text-box" />
            </label>
          </div>
          <div class="pt-8">
            <label>
              <span class="text-sm">Revision Notes</span>
              <textarea [(ngModel)]="audit.AuditInfo.RevisionNotes" (ngModelChange)="auditChanged()" type="text"
              class="text-box" rows="3"></textarea>
            </label>
          </div>
          <div class="pt-8">
            <label>
              <span class="text-sm">Frequency*</span>
              <select [(ngModel)]="audit.AuditInfo.Frequency" (ngModelChange)="auditChanged()"
                [compareWith]="auditTypeComparison" class="text-box">
                @for (t of _frequencies; track t) {
                  <option [disabled]="!t.Active" [ngValue]="t">{{t.Description}}
                  </option>
                }
              </select>
            </label>
          </div>
          <div class="pt-8">
            <label>
              <span class="text-sm">Frequency Multiplier*</span>
              <input [(ngModel)]="audit.AuditInfo.FrequencyMultiplier" (ngModelChange)="auditChanged()" type="number"
                class="text-box" />
              </label>
            </div>
            <div class="pt-2">
              <p class="italic text-sm">*Required fields</p>
            </div>
          </div>
        }

      </div>
